<template>
  <main class="home">
    <StatementDetails />
  </main>
</template>

<script lang="ts" setup>
import { onBeforeMount, getCurrentInstance } from "vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import StatementDetails from "@/apps/credit-line/components/StatementDetails.vue";

const instance = getCurrentInstance();

onBeforeMount(() => {
  if (instance && instance.proxy) {
    setLanguage(instance.proxy);
  }
});
</script>
